import script from "./LouisanaView.vue?vue&type=script&setup=true&lang=js"
export * from "./LouisanaView.vue?vue&type=script&setup=true&lang=js"

import "./LouisanaView.vue?vue&type=style&index=0&id=28268dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28268dee"]])

export default __exports__